module.exports = __webpack_public_path__ + "img/fish.831129e2.svg";